var map = {
	"./behind_the_scenes.mp4": 1481,
	"./behind_the_scenes.png": 1482,
	"./jitter.mp4": 1483,
	"./jitter.png": 1484,
	"./lag_wtf.mp4": 1485,
	"./lag_wtf.png": 1486,
	"./latency.mp4": 1487,
	"./latency.png": 1488,
	"./packet_loss.mp4": 1489,
	"./packet_loss.png": 1490,
	"./sync.mp4": 1491,
	"./sync.png": 1492,
	"./what_is_lag.mp4": 1493,
	"./what_is_lag.png": 1494
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1498;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations ^\.\/.*$
// module id = 1498
// module chunks = 39